import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class RoamingCardsRepository extends CrudRepository {
  constructor () {
    super('/customerCare/api/communicationProvider/country')
  }

  async getFilterById (id, lineType) {
    const data = await Repository.get(`${this.resource}/${id}`, { params: { lineType: lineType } })
    return data.data
  }
}
